import {mutators} from '@cypro/engine/mutators'
import {queries} from '@cypro/engine/queries'
import {BasicDataResources} from '@cypro/engine/schema'

export const BasicDataResourceToQueriesMap = {
  [BasicDataResources.adminRoutes]: {
    listItems: queries.basicData.listAdminRoutes,
    getItem: queries.basicData.getAdminRouteById,
    getItemActivities: queries.basicData.getAdminRouteActivitiesById,
  },
  [BasicDataResources.applicationForms]: {
    listItems: queries.basicData.listApplicationForms,
    getItem: queries.basicData.getApplicationFormById,
    getItemActivities: queries.basicData.getApplicationFormActivitiesById,
  },
  [BasicDataResources.containerMaterials]: {
    listItems: queries.basicData.listContainerMaterials,
    getItem: queries.basicData.getContainerMaterialById,
    getItemActivities: queries.basicData.getContainerMaterialActivitiesById,
  },
  [BasicDataResources.containerTypes]: {
    listItems: queries.basicData.listContainerTypes,
    getItem: queries.basicData.getContainerTypeById,
    getItemActivities: queries.basicData.getContainerTypeActivitiesById,
  },
  [BasicDataResources.diagnoses]: {
    listItems: queries.basicData.listDiagnoses,
    getItem: queries.basicData.getDiagnosisById,
    getItemActivities: queries.basicData.getDiagnosisActivitiesById,
  },
  [BasicDataResources.hazardClasses]: {
    listItems: queries.basicData.listHazardClasses,
    getItem: queries.basicData.getHazardClassById,
    getItemActivities: queries.basicData.getHazardClassActivitiesById,
  },
  [BasicDataResources.solutionTypes]: {
    listItems: queries.basicData.listSolutionTypes,
    getItem: queries.basicData.getSolutionTypeById,
    getItemActivities: queries.basicData.getSolutionTypeActivitiesById,
  },
  [BasicDataResources.medicineForms]: {
    listItems: queries.basicData.listMedicineForms,
    getItem: queries.basicData.getMedicineFormById,
    getItemActivities: queries.basicData.getMedicineFormActivitiesById,
  },
  [BasicDataResources.cancerTypes]: {
    listItems: queries.basicData.listCancerTypes,
    getItem: queries.basicData.getCancerTypeById,
    getItemActivities: queries.basicData.getCancerTypeActivitiesById,
  },
  [BasicDataResources.companies]: {
    listItems: queries.basicData.listCompanies,
    getItem: queries.basicData.getCompanyById,
    getItemActivities: queries.basicData.getCompanyActivitiesById,
  },
  [BasicDataResources.stockLocations]: {
    listItems: queries.basicData.listStockLocations,
    getItem: queries.basicData.getStockLocationById,
    getItemActivities: queries.basicData.getStockLocationActivitiesById,
  },
  [BasicDataResources.treatmentChairs]: {
    listItems: queries.basicData.listTreatmentChairs,
    getItem: queries.basicData.getTreatmentChairById,
    getItemActivities: queries.basicData.getTreatmentChairActivitiesById,
  },
  [BasicDataResources.storageLabels]: {
    listItems: queries.basicData.listStorageLabels,
    getItem: queries.basicData.getStorageLabelById,
    getItemActivities: queries.basicData.getStorageLabelActivitiesById,
  },
  [BasicDataResources.insuranceCompanies]: {
    listItems: queries.basicData.listInsuranceCompanies,
    getItem: queries.basicData.getInsuranceCompanyById,
    getItemActivities: queries.basicData.getInsuranceCompanyActivitiesById,
  },
  [BasicDataResources.generalPhysicians]: {
    listItems: queries.basicData.listGeneralPhysicians,
    getItem: queries.basicData.getGeneralPhysicianById,
    getItemActivities: queries.basicData.getGeneralPhysicianActivitiesById,
  },
} as const

export const BasicDataResourceToMutatorsMap = {
  [BasicDataResources.adminRoutes]: mutators.basicData.adminRoutes,
  [BasicDataResources.applicationForms]: mutators.basicData.applicationForms,
  [BasicDataResources.containerMaterials]: mutators.basicData.containerMaterials,
  [BasicDataResources.containerTypes]: mutators.basicData.containerTypes,
  [BasicDataResources.diagnoses]: mutators.basicData.diagnoses,
  [BasicDataResources.hazardClasses]: mutators.basicData.hazardClasses,
  [BasicDataResources.solutionTypes]: undefined, // they are not handled through the CMS, only saved in the DB
  [BasicDataResources.medicineForms]: mutators.basicData.medicineForms,
  [BasicDataResources.cancerTypes]: mutators.basicData.cancerTypes,
  [BasicDataResources.companies]: mutators.basicData.companies,
  [BasicDataResources.stockLocations]: mutators.basicData.stockLocations,
  [BasicDataResources.treatmentChairs]: mutators.basicData.treatmentChairs,
  [BasicDataResources.storageLabels]: mutators.basicData.storageLabels,
  [BasicDataResources.insuranceCompanies]: mutators.basicData.insuranceCompanies,
  [BasicDataResources.generalPhysicians]: mutators.basicData.generalPhysicians,
} as const
